import useAuthStore from "@/mixins/globals/stores/useAuthStore";

export default {
    install(Vue) {
        Vue.mixin(useAuthStore)
    }
}